'use client';

import {
  createContext,
  type TransitionStartFunction,
  useContext,
  useTransition
} from 'react';

type ContextType = {
  isPending: boolean;
  startTransition: TransitionStartFunction;
};

const PricingUpdateContext = createContext<ContextType>({
  isPending: false,
  startTransition(callback) {
    callback();
  }
});

export function PricingUpdateProvider({ children }: React.PropsWithChildren) {
  const [isPending, startTransition] = useTransition();

  return (
    <PricingUpdateContext.Provider value={{ isPending, startTransition }}>
      {children}
    </PricingUpdateContext.Provider>
  );
}

export function usePricingUpdate() {
  return useContext(PricingUpdateContext);
}

export function MockedPricingUpdateProvider({
  children,
  mockValue
}: React.PropsWithChildren<{ mockValue?: Partial<ContextType> }>) {
  return (
    <PricingUpdateContext.Provider
      value={{
        isPending: false,
        startTransition(callback) {
          callback();
        },
        ...mockValue
      }}
    >
      {children}
    </PricingUpdateContext.Provider>
  );
}
